import React from "react";

const NonInventoryModule = React.lazy(() => import("./ui/NonInventory"));

export const NonInventoryPage = () => {
  return <NonInventoryModule />;
};
